/**
 * How far the gesture's own floating UI sits below the pointer. Enough for the
 * cursor, which is drawn over anything anchored at the pointer, to clear the
 * top edge - a tooltip's arrow or a picker's first row.
 */
export const POINTER_GAP = 7;

/**
 * How long the gesture waits for a created reference to turn up in the loaded
 * graph before letting the next one start anyway. A dropped websocket event
 * should cost the duplicate guard, not the gesture.
 */
export const CREATE_SETTLE_TIMEOUT_MS = 10_000;

export const SEARCH_BOX_ATTRIBUTE = 'data-noodle-search-box';

export const SEARCH_BOX_SELECTOR = `[${SEARCH_BOX_ATTRIBUTE}]`;
